import { ROLES } from './types';

const server = import.meta.env.PROD
  ? import.meta.env.VITE_PROD_API_SERVER_IP
  : import.meta.env.VITE_LOCAL_API_SERVER_IP;

/**
 * Route pathname constants for string comparisons only.
 *
 * Note: For navigation, use TanStack Router's type-safe `to` parameter directly.
 * These constants are only needed for pathname string comparisons like:
 * - window.location.pathname !== ROUTE_PATHS.LOGIN
 * - router.state.location.pathname !== ROUTE_PATHS.LOGIN
 *
 * TanStack Router provides type safety for navigation through the generated
 * route tree, so prefer using the typed `to` parameter in navigate() and redirect().
 */
const ROUTE_PATHS = {
  LOGIN: '/login',
  RESET_PASSWORD: '/reset-password',
} as const;

const publicRoutes: string[] = [ROUTE_PATHS.RESET_PASSWORD, ROUTE_PATHS.LOGIN];

/**
 * Shared React Query cache timing for organizations-related queries.
 *
 * - ORGS_QUERY_STALE_TIME: How long organization data is considered fresh (ms)
 * - ORGS_QUERY_GC_TIME: How long unused organization data stays in cache (ms)
 *
 * Organizations change infrequently, so we use long cache times.
 */
export const ORGS_QUERY_STALE_TIME = 30 * 24 * 60 * 60 * 1000; // 30 days
export const ORGS_QUERY_GC_TIME = 60 * 24 * 60 * 60 * 1000; // 60 days

/**
 * Shared React Query cache timing for studies-related queries.
 *
 * - STUDIES_QUERY_STALE_TIME: How long studies data is considered fresh (ms)
 * - STUDIES_QUERY_GC_TIME: How long unused studies data stays in cache (ms)
 *
 * Set longer for studies-heavy navigation UX.
 */
export const STUDIES_QUERY_STALE_TIME = 30 * 60 * 1000; // 30 minutes
export const STUDIES_QUERY_GC_TIME = 60 * 60 * 1000; // 60 minutes

/**
 * Pagination settings for sample proteoform tables
 */
export const SAMPLE_PROTEOFORMS_PAGE_SIZE = 24;
export const SAMPLE_PROTEOFORMS_PAGE_SIZE_OPTIONS = [4, 12, 24];

/**
 * Proteoform query configuration
 */
export const PROTEOFORM_QUERY_LIMIT = 500;
export const PROTEOFORM_DEFAULT_SORT_BY = 'sample_name' as const;
export const PROTEOFORM_DEFAULT_SORT_ORDER = 'asc' as const;
export const PLACEHOLDER_VALUE = '-';

/**
 * Default column definition settings
 */
const defaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
};

const adminRoles = [ROLES[0], ROLES[1]];

// Standardized icon size for main icons across the application
const mainIconSize = 20;
const smIconSize = 14;

export { adminRoles, defaultColDef, mainIconSize, publicRoutes, ROUTE_PATHS, server, smIconSize };
